type IconDashboardProps = {
    className?: string;
};

export function IconDashboard(props: IconDashboardProps) {
    const { className = '' } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            aria-hidden={true}
            className={`${className}`}
        >
            <path
                d="M0 0H8V8H0V0ZM10 0H18V8H10V0ZM0 10H8V18H0V10ZM13 10H15V13H18V15H15V18H13V15H10V13H13V10ZM12 2V6H16V2H12ZM2 2V6H6V2H2ZM2 12V16H6V12H2Z"
                fill={'black'}
            />
        </svg>
    );
}

export default IconDashboard;
